export const BackgroundSVG = ({ className = "" }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 1440 403"
    >
      <g clipPath="url(#a)">
        <path fill="#FFF3E6" d="M0 0h1440v403H0z" />
        <path
          stroke="#FFF3E6"
          strokeWidth="3.909"
          d="m200.799 331.28-26.063 26.062m26.063-26.062v21.982m0-21.982h-21.982"
        />
        <path fill="#FFBF6E" d="M1440.44 56.973h-57.403v57.12h57.403z" />
        <path
          fill="#FFBF6E"
          d="M1325.64 56.973h-57.403v57.12h57.403z"
          opacity=".2"
        />
        <path
          fill="#FFBF6E"
          d="M1210.83 56.973h-56.728v57.12h56.728z"
          opacity=".3"
        />
        <path fill="#1F3121" d="M1440.44-.146h-57.403v57.12h57.403z" />
        <path fill="#C1B7FF" d="M1325.64-.146h-57.403v57.12h57.403z" />
        <path fill="#F0F1FA" d="M1210.83-.146h-56.728v57.12h56.728z" />
        <path fill="#C1B7FF" d="M1440.44 114.093h-57.403v58.464h57.403z" />
        <path fill="#F0F1FA" d="M1440.44 172.557h-57.403v57.792h57.403z" />
        <path fill="#2B2358" d="M1325.64 172.557h-57.403v57.792h57.403z" />
        <path
          fill="#FFBF6E"
          d="M1210.83 172.557h-56.728v57.792h56.728z"
          opacity=".1"
        />
        <path fill="#1F3121" d="M1440.44 230.349h-57.403v57.792h57.403z" />
        <path fill="#C1B7FF" d="M1325.64 230.349h-57.403v57.792h57.403z" />
        <path fill="#FF4F00" d="M1440.44 288.14h-57.403v57.792h57.403z" />
        <path
          fill="#FFBF6E"
          d="M1325.64 288.14h-57.403v57.792h57.403z"
          opacity=".2"
        />
        <path fill="#FFBF6E" d="M1210.83 288.14h-56.728v57.792h56.728z" />
        <path
          fill="#CDE4E1"
          d="M1383.04 57.347h-57.403v57.12h57.403z"
          opacity=".5"
        />
        <path fill="#FF4F00" d="M1268.23 56.973h-57.403v57.12h57.403z" />
        <path fill="#C1B7FF" d="M1440.44 345.932h-57.403v57.12h57.403z" />
        <path fill="#2B2358" d="M1325.64 345.932h-57.403v57.12h57.403z" />
        <path fill="#EBE9F7" d="M1210.83 345.932h-56.728v57.12h56.728z" />
        <path fill="#FF4F00" d="M1383.04-.146h-57.403v57.12h57.403z" />
        <path
          fill="#FFBF6E"
          d="M1268.23.227h-57.403v57.12h57.403z"
          opacity=".2"
        />
        <path
          fill="#FF4F00"
          d="M1383.04 172.557h-57.403v57.792h57.403zM1268.23 172.557h-57.403v57.792h57.403z"
        />
        <path
          fill="#FFBF6E"
          d="M1383.04 114.093h-57.403v58.464h57.403z"
          opacity=".3"
        />
        <path
          fill="#FFBF6E"
          d="M1268.23 114.093h-57.403v58.464h57.403z"
          opacity=".2"
        />
        <path fill="#CDE4E1" d="M1383.04 288.14h-57.403v57.792h57.403z" />
        <path fill="#FFBF6E" d="M1325.64 114.765h-57.403v57.792h57.403z" />
        <path
          fill="#CDE4E1"
          d="M1268.23 288.14h-57.403v57.792h57.403z"
          opacity=".5"
        />
        <path
          fill="#FFBF6E"
          d="M1383.04 230.349h-57.403v57.792h57.403z"
          opacity=".1"
        />
        <path
          fill="#FFBF6E"
          d="M1268.23 230.349h-57.403v57.792h57.403z"
          opacity=".2"
        />
        <path fill="#2B2358" d="M1210.74-.744h-57.403v57.792h57.403z" />
        <path
          fill="#C1B7FF"
          d="M1089.27 44.205h-57.403v57.792h57.403z"
          opacity=".2"
        />
        <path
          fill="#C1B7FF"
          d="M1031.85-13.806h-57.403v57.792h57.403zM981.965 324.308h-57.403V382.1h57.403z"
          opacity=".1"
        />
        <path
          fill="#C1B7FF"
          d="M855.199 358.642h-57.403v57.792h57.403zM694.903 300.757H637.5v57.792h57.403zM453.403 323.893H396v57.792h57.403zM223.153 358.969H165.75v57.792h57.403zM43.903 294.787H-13.5v57.792h57.403z"
          opacity=".05"
        />
        <path
          fill="#C1B7FF"
          d="M924.583 44.412H867.18v57.792h57.403z"
          opacity=".1"
        />
        <path
          fill="#C1B7FF"
          d="M810.193-19.404H752.79v57.792h57.403zM682.153 70.152H624.75v57.792h57.403zM426.404-12.687h-57.403v57.792h57.403zM211.154 27.613h-57.403v57.792h57.403z"
          opacity=".05"
        />
        <path
          fill="#C1B7FF"
          d="M1096.7 288.14h-57.403v57.792h57.403z"
          opacity=".4"
        />
        <path
          fill="#FFBF6E"
          d="M1383.04 345.932h-57.403v57.12h57.403z"
          opacity=".3"
        />
        <path
          fill="#FFBF6E"
          d="M1268.23 345.932h-57.403v57.12h57.403z"
          opacity=".1"
        />
        <path fill="#FF4F00" d="M1154.1 345.932h-57.403v57.12h57.403z" />
        <path
          fill="#1F3121"
          stroke="#C1B7FF"
          d="M1419.94 128.033h-24.07v23.954l4.5 4.485v-20.799l.86.85 22.47 22.392 3.2-3.185-22.5-22.362-.86-.855h20.91l-4.51-4.48Z"
        />
        <path
          fill="#CDE4E1"
          stroke="#1F3121"
          d="M1419.94 12.45h-24.07v23.954l4.5 4.485V20.09l.86.85 22.47 22.392 3.2-3.185-22.5-22.362-.86-.855h20.91l-4.51-4.48Z"
        />
        <path
          fill="#1F3121"
          stroke="#FF4F00"
          d="M1419.94 301.409h-24.07v23.954l4.5 4.485v-20.799l.86.85 22.47 22.392 3.2-3.185-22.5-22.362-.86-.855h20.91l-4.51-4.48Z"
        />
        <path
          fill="#FFF3E6"
          d="m1141.27 383.362-5.51 5.481v-20.799l-22.83 22.744-3.91-3.891 22.86-22.716h-20.9l5.51-5.481h24.78v24.662ZM1313.1 210.515l-5.51 5.48v-20.798l-22.82 22.743-3.91-3.891 22.85-22.716h-20.9l5.51-5.48h24.78v24.662ZM1255.72 94.825l-5.51 5.481V79.507l-22.83 22.744-3.91-3.891 22.86-22.716h-20.9l5.51-5.48h24.78v24.661Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h1440v403H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
